/**
 * 检查是否是顶层框架
 */
export const checkIsTopFrame = () => {
    return window.top === window.self
}
